import React, {useEffect, useRef} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ServiceCard from "../components/servicecard";

gsap.registerPlugin(ScrollTrigger);

const services = [{
    id: 1,
    title: "SOLAR PV INSTALLATION",
    description: "We specialize in the design, installation, and maintenance of solar photovoltaic (PV) systems for residential, commercial, and industrial properties. Our team of experts ensures that each installation is tailored to the specific needs of our clients, maximizing energy production and efficiency.",
    image: "../images/services/solarInstall.jpg",
}, {
    id: 2,
    title: "AFTER SALES SERVICE & MAINTENANCE",
    description: "Ensuring that your solar PV system is operating at peak performance is crucial for maximizing your energy savings. Our maintenance and repair services are designed to keep your system running smoothly, identifying and addressing any issues before they become major problems.",
    image: "../images/services/solarService.jpg",
},];

const Services = () => {
    const headingRef = useRef(null);

    useEffect(() => {
        gsap.fromTo(headingRef.current, {opacity: 0, y: -50}, {
            opacity: 1, y: 0, duration: 1.5, ease: "power2.out", scrollTrigger: {
                trigger: headingRef.current, start: "top 85%", end: "top 50%", scrub: true,
            },
        });
    }, []);

    return (<div
        className="w-full  pt-6 pb-10 bg-white flex flex-col items-center justify-center px-4 md:px-12 text-customblue overflow-hidden">
        <div className="text-center mb-12">
            <h1
                ref={headingRef}
                className="font-montserrat text-4xl sm:text-5xl md:text-6xl font-bold text-[#031c3f]"
            >
                OUR SERVICES
            </h1>
        </div>

        <div className="w-full max-w-screen-2xl flex flex-wrap justify-center gap-8">
            {services.map((service, index) => (<ServiceCard
                key={service.id}
                title={service.title}
                description={service.description}
                image={service.image}
                index={index}
            />))}
        </div>

    </div>);
};

export default Services;
